import { render, staticRenderFns } from "./ElementAdditionalSetting.vue?vue&type=template&id=0bfec0db&scoped=true"
import script from "./ElementAdditionalSetting.vue?vue&type=script&lang=js"
export * from "./ElementAdditionalSetting.vue?vue&type=script&lang=js"
import style0 from "./ElementAdditionalSetting.vue?vue&type=style&index=0&id=0bfec0db&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bfec0db",
  null
  
)

export default component.exports